import { AppModule } from 'app/module';
import { KEYCODE_ENTER } from 'app/keyCodes';
import Template from './template.hbs';
import './styles.scss';

export class Toggle extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            input: '.k-c-toggle__input',
            symbol: '.k-c-toggle__symbol',
        };
    }

    getPropsFromDom() {
        return {
            checked: !!this.dom.input.checked,
        };
    }

    domEvents() {
        this.dom.input.addEventListener('click', () => this.sendEvent());
        this.dom.symbol.addEventListener('keyup', (e) => {
            if (e.key === KEYCODE_ENTER) {
                this.dom.input.click();
            }
        });
    }

    sendEvent() {
        this.events.emit('toggleClick', !this.props.checked);
        this.setToggleProps();
    }

    revertToggleStatus() {
        this.dom.input.checked = !this.props.checked;
        this.setToggleProps();
    }

    switchDisable() {
        this.dom.input.disabled = !this.dom.input.disabled;
    }

    setToggleProps() {
        this.setProps({ checked: !this.props.checked });
    }
}
